import React, { useRef } from "react";

/**
 * Color field with a popup picker. The swatch button opens the browser's
 * native color picker (hidden input[type=color]); the text input still
 * accepts a raw #RRGGBB value for paste/precision.
 */
export default function ColorPickerField({
  value,
  onChange,
  inputStyle,
  placeholder = "#RRGGBB",
}: {
  value: string;
  onChange: (v: string) => void;
  inputStyle?: React.CSSProperties;
  placeholder?: string;
}) {
  const pickerRef = useRef<HTMLInputElement>(null);
  const valid = /^#[0-9a-fA-F]{6}$/.test(value || "");
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
      <button
        type="button"
        aria-label="Pick color"
        title={valid ? value : "Pick color"}
        onClick={() => pickerRef.current?.click()}
        style={{
          width: "28px",
          height: "28px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          background: valid ? value : "#ffffff",
          cursor: "pointer",
          padding: 0,
          flexShrink: 0,
        }}
      />
      <input
        ref={pickerRef}
        type="color"
        aria-hidden="true"
        tabIndex={-1}
        value={valid ? value : "#ffffff"}
        onChange={(e) => onChange(e.target.value)}
        style={{
          position: "absolute",
          opacity: 0,
          width: "1px",
          height: "1px",
          pointerEvents: "none",
        }}
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={inputStyle}
        placeholder={placeholder}
      />
    </span>
  );
}
